import noiseMonitoringIcon from '@/assets/icons/noise monitoring.svg'
import clockIcon from '@/assets/icons/Clock.svg'
import powerAndFuelIcon from '@/assets/icons/power and fuel.svg'
import weatherIcon from '@/assets/icons/weather.svg'
import type { IndustryPageContent } from './types'

// Copy: content/unimo-industry-page-copy.md, "EVENTS" — signed off 28 Aug 2026.
// Stats/citations: content/unimo-industry-stats.md v7 (final) — same date.
// Hero headline is the only thing carried over from the old live page at
// src/features/industries/EventsPage.tsx — nothing else from it.
export const eventsContent: IndustryPageContent = {
    key: 'events',
    hero: {
        headlineLine1: 'Protect Your Licence.',
        headlineLine2: 'Just Ask.',
    },
    statBand: {
        header: 'What events teams are up against.',
        stats: [
            {
                // Type B: word unit on its own line, figure stays "380".
                figure: '380',
                unitPhrase: 'million litres',
                body: "of diesel go through UK events every year. Knowing where it went shouldn't be a guess.",
                citation: 1,
            },
            {
                // Type C, approved display change from "300,000+" — see
                // content/unimo-industry-stats.md changelog and docs/build-log.md.
                // Underlying figure (306,956, "over 300,000") is unchanged.
                figure: '300',
                unit: 'K+',
                body: 'noise complaints reach councils every year. A curfew is not a formality.',
                citation: 2,
            },
            {
                figure: '50',
                unit: '%',
                body: 'of UK events businesses now add a fuel surcharge. Fuel stopped being a rounding error.',
                citation: 3,
            },
        ],
    },
    usps: [
        {
            title: 'Multi-zone noise monitoring',
            body: 'Council-grade dB sensors at every key location. See real-time levels across main stage, second stage and boundary points.',
            icon: noiseMonitoringIcon,
        },
        {
            title: 'Curfew countdown alerts',
            body: 'Know your levels before curfew hits. Configurable warnings at -30, -15 and -5 minutes give sound engineers time to adjust.',
            icon: clockIcon,
        },
        {
            title: 'Power and generator tracking',
            body: 'Multiple generators across a temporary site? See load, runtime and fuel consumption. Cut waste and prove carbon footprint.',
            icon: powerAndFuelIcon,
        },
        {
            title: 'Environmental conditions',
            body: 'Temperature, humidity, air quality. Know conditions across camping, backstage and public areas. Keep people safe.',
            icon: weatherIcon,
        },
    ],
    closingCta: {
        headline: 'Ready to protect your licence?',
    },
    references: [
        {
            id: 1,
            text: "Powerful Thinking, with A Greener Festival, Julie's Bicycle and ZAP Concepts, Diesel use at UK events, 2019, as reported by Event Industry News.",
            italicPhrase: 'Diesel use at UK events',
            url: 'https://www.eventindustrynews.com/news/industry-report-reveals-extent-of-uk-festival-and-events-diesel-emissions-and-impact-on-public-health',
            linkLabel: 'eventindustrynews.com',
        },
        {
            id: 2,
            text: 'Chartered Institute of Environmental Health, Noise Complaint Data Briefing 2026. London: CIEH, 2026.',
            italicPhrase: 'Noise Complaint Data Briefing 2026',
            url: 'https://www.cieh.org/noise-data-2026',
            linkLabel: 'cieh.org',
        },
        {
            id: 3,
            text: 'National Outdoor Events Association, NOEA Confidence Monitor, June 2026.',
            italicPhrase: 'NOEA Confidence Monitor',
            url: 'https://www.noea.org.uk/noea-confidence-monitor-reveals-growing-commercial-impact-across-uk-events-sector/',
            linkLabel: 'noea.org.uk',
        },
    ],
}

export default eventsContent
